import { render, staticRenderFns } from "./TravelLogClient.vue?vue&type=template&id=537a818a"
import script from "./TravelLogClient.vue?vue&type=script&lang=js"
export * from "./TravelLogClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports